var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"az-content-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"SectionItem no-b-b"},[_c('div',{staticClass:"SectionHeader"},[_c('span',{staticClass:"title"},[_vm._v("Account")]),_c('div',{staticClass:"description"},[_vm._v("Customize advanced settings for conversations")])])])])])])
}]

export { render, staticRenderFns }